import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import {
  dateToString,
  removeReadOnlyFields,
  stringToDate,
} from 'src/utils/fieldNormalizers';

import { UserPackage } from './user-package';

const serviceCountReadOnlyFields = [
  'name',
  'remaining',
  'used',
  'used_guests',
  'guests_remaining',
  'services',
];

const readOnlyFields = [
  'package_id',
  'location',
  'location_name',
  'assigned_trainer_name',
  'subscription_id',
  'service_ids',
  'created_at',
  'name',
  'payment_method',
  'payment_type',
  'from_invoice',
  'links',
  'from_automation',
  'auto_renew_max_cycles',
  'auto_renew_current_cycles',
  'auto_renew_id',
  'owner_id',
  'external_payment_method',
  'updated_at',
  'assigned_trainer',
  'package',
  'users',
  'signature',
  'kisi_failed_payment_limit',
  'subscription',
];

const dateStringKeys = ['activation_date', 'expires_on'];

export function normalizeUserPackage(pkg: any): UserPackage {
  const camelized = camelcaseKeys(pkg, { deep: true });
  return {
    ...camelized,
    ...(camelized.activationDate && {
      activationDate: stringToDate(camelized.activationDate),
    }),
    ...(camelized.expiresOn && {
      expiresOn: stringToDate(camelized.expiresOn),
    }),
  } as UserPackage;
}

export function denormalizeUserPackage(pkg: Partial<UserPackage>): any {
  delete pkg.id;
  const decamelized = decamelizeKeys(pkg, { deep: true });
  removeReadOnlyFields(decamelized, readOnlyFields);

  dateStringKeys.forEach((key) => {
    if (decamelized[key]) {
      decamelized[key] = dateToString(decamelized[key]);
    }
  });

  decamelized.service_counts?.forEach((serviceCount) => {
    removeReadOnlyFields(serviceCount, serviceCountReadOnlyFields);
  });
  return decamelized;
}
